const config = [
  {
    key: 'zh-Hans',
    value: '简体中文',
    languageTeam: 'Chinese Simplified',
    language: 'zh_CN',
    path: '/staticfiles/lang/zh-Hans/mdTranslation.js',
  },
  {
    key: 'zh-Hant',
    value: '繁體中文',
    languageTeam: 'Chinese Traditional',
    language: 'zh_TW',
    path: '/staticfiles/lang/zh-Hant/mdTranslation.js',
  },
  {
    key: 'en',
    value: 'English',
    languageTeam: 'English',
    language: 'en_US',
    path: '/staticfiles/lang/en/mdTranslation.js',
  },
  {
    key: 'ja',
    value: '日本語',
    languageTeam: 'Japanese',
    language: 'ja',
    path: '/staticfiles/lang/ja/mdTranslation.js',
  },
  {
    key: 'ko',
    value: '한국어',
    languageTeam: 'Korean',
    language: 'ko',
    path: '/staticfiles/lang/ko/mdTranslation.js',
  },
];

export default config;
